// import React, { useEffect, useState } from "react";
// import "./Dashboard.css";
// import { GetRoute } from "../../Custom_hooks/Routes";
// import { useMediaQuery } from "../../Custom_hooks/Custom";
// import { MovingBorder } from "@/components/ui/moving-border";
// import CustomModal from "Components/CustomComponents/CustomModal/CustomModal";
// import CustomInput from "Components/CustomComponents/CustomInput/CustomInput";
// import CustomButton from "Components/CustomComponents/CustomButton/CustomButton";
// import { useSelector } from "react-redux";
// import { motion } from "framer-motion";
// import { Users, UserCheck, BarChart3 } from "lucide-react";

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer,
//   BarChart,
//   Bar,
// } from "recharts";

// const Card = ({ className = "", children }) => (
//   <div className={`rounded-2xl shadow-lg ${className}`}>{children}</div>
// );

// const CardContent = ({ className = "", children }) => (
//   <div className={className}>{children}</div>
// );

// const Button = ({ className = "", children, ...props }) => (
//   <button
//     {...props}
//     className={`px-4 py-2 rounded-xl bg-[#333F6B] text-white hover:opacity-90 transition ${className}`}
//   >
//     {children}
//   </button>
// );

// const chartData = [
//   { month: "Jan", students: 200 },
//   { month: "Feb", students: 350 },
//   { month: "Mar", students: 500 },
//   { month: "Apr", students: 700 },
//   { month: "May", students: 900 },
// ];

// const AdminDashboard = () => {
//   const isMobile = useMediaQuery("(max-width:700px)");
//   const [length, setLength] = useState(0);
//   const [showCard, setShowCard] = useState(null);
//   const [popup, setpopup] = useState(false);

//   const auth = useSelector((state) => state.user.auth);
//   const admins2 = [
//     {
//       name: "Root User",
//       adminId: "root.rvgo@gmail.com",
//       status: "Active",
//       featuresAllowed: ["All"],
//       createdAt: new Date(),
//     },
//     {
//       name: "Temp User",
//       adminId: "temp@gmail.com",
//       status: "Active",
//       featuresAllowed: ["All"],
//       createdAt: new Date(),
//     },
//   ];

//   const admins = [
//     {
//       name: "Root User",
//       adminId: "root.buzzai@gmail.com",
//       status: "Active",
//       featuresAllowed: ["All"],
//       createdAt: new Date(),
//     },
//     {
//       name: "Temp User",
//       adminId: "temp@gmail.com",
//       status: "Active",
//       featuresAllowed: ["All"],
//       createdAt: new Date(),
//     },
//   ];

//   const handleFindTotalStudents = () => {
//     GetRoute(
//       `getAllUsers`,
//       () => {},
//       (data) => {
//         setLength(data.length);
//       }
//     );
//   };

//   useEffect(() => {
//     handleFindTotalStudents();
//   }, []);

//   const stats = [
//     { title: "Total Students", value: `${length} +`, icon: Users },
//     { title: "Active Students", value: length, icon: UserCheck },
//     { title: "Tests Conducted", value: `50 +`, icon: BarChart3 },
//   ];
//   const headerStyle = {
//     backgroundColor: "rgb(108, 108, 108)",
//     color: "#fff",
//     padding: "5px",
//     textAlign: "left",
//     border: "1px solid #ccc",
//     fontSize: isMobile ? "2vw" : "1.2vw",
//   };

//   const cellStyle = {
//     padding: "5px",
//     border: "1px solid #ccc",
//     cursor: "pointer",
//     fontSize: isMobile ? "2vw" : "1vw ",
//   };

//   return (
//     <>
//       {popup && (
//         <CustomModal isOpen={""} open={""} close={""}>
//           <div>
//             <div
//               style={{
//                 fontSize: !isMobile ? "1.5vw" : "5vw",
//                 color: "rgb(50, 50,255)",
//               }}
//             >
//               Create New Admin
//             </div>
//             <CustomInput
//               label={"Admin Name"}
//               placeholder={"Enter admin name"}
//             />
//             <CustomInput
//               label={"Admin Id"}
//               placeholder={"Enter admin id/email id"}
//             />
//             <CustomInput
//               label={"Password"}
//               placeholder={"Enter admin password"}
//             />
//             <CustomInput
//               label={"Select Features to Allocate"}
//               inputStyle={{ display: "none" }}
//             />
//             <div style={{ display: "flex", gap: "2%", width: "100%" }}>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <input
//                   type="checkbox"
//                   name=""
//                   id=""
//                   style={{
//                     height: !isMobile ? "1.2vw" : "3vw",
//                     width: !isMobile ? "1.2vw" : "3vw",
//                   }}
//                 />
//                 &nbsp; Question Database
//               </div>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <input
//                   type="checkbox"
//                   name=""
//                   id=""
//                   style={{
//                     height: !isMobile ? "1.2vw" : "3vw",
//                     width: !isMobile ? "1.2vw" : "3vw",
//                   }}
//                 />
//                 &nbsp; Upload Tests
//               </div>
//               <div style={{ display: "flex", alignItems: "center" }}>
//                 <input
//                   type="checkbox"
//                   name=""
//                   id=""
//                   style={{
//                     height: !isMobile ? "1.2vw" : "3vw",
//                     width: !isMobile ? "1.2vw" : "3vw",
//                   }}
//                 />
//                 &nbsp;See Users
//               </div>
//             </div>
//             <div style={{ display: "flex", gap: "2%" }}>
//               <CustomButton text={"Save"} />
//               <CustomButton
//                 handleClick={() => setpopup(false)}
//                 text={"Cancel"}
//                 style={{ backgroundColor: "red" }}
//               />
//             </div>
//           </div>
//         </CustomModal>
//       )}
//       <div
//         className="dashboardContainer"
//       >
//         <div className="min-h-screen bg-white p-6 text-gray-800">
//           {/* Top Gradient Header */}
//           <motion.div
//             initial={{ opacity: 0, y: -20 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="mb-10 h-40 rounded-2xl bg-gradient-to-r from-[#6A85B6] to-[#BAC8E0] p-6 shadow-lg flex justify-between items-center"
//           >
//             <div>
//               <h1 className="text-2xl font-bold text-white">
//                 WELCOME ADMIN 👋
//               </h1>
//               <p className="text-sm text-white/80">{auth.data.email}</p>
//             </div>
//             <div className="flex items-center gap-3">
//               <div className="w-12 h-12 rounded-full bg-white/30 flex items-center justify-center text-white font-bold">
//                 👤
//               </div>
//             </div>
//           </motion.div>

//           {/* Stats Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
//             {stats.map((stat, index) => (
//               <motion.div
//                 key={stat.title}
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 transition={{ delay: index * 0.1 }}
//               >
//                 <Card className="bg-white/10 backdrop-blur-xl border-none rounded-2xl shadow-lg bg-gradient-to-r from-[#6A85B6] to-[#BAC8E0]">
//                   <CardContent className="flex items-center justify-between p-6">
//                     <div>
//                       <p className="text-sm text-gray-300">{stat.title}</p>
//                       <h2 className="text-3xl font-semibold">{stat.value}</h2>
//                     </div>
//                     <stat.icon className="w-10 h-10 text-white/70" />
//                   </CardContent>
//                 </Card>
//               </motion.div>
//             ))}
//           </div>

//           {/* Charts Section */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-10">
//             <Card className="bg-white/10 backdrop-blur-xl border-none rounded-2xl">
//               <CardContent className="p-6">
//                 <h3 className="mb-4 text-lg font-semibold">Student Growth</h3>
//                 <ResponsiveContainer width="100%" height={300}>
//                   <LineChart data={chartData}>
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <Tooltip />
//                     <Line type="monotone" dataKey="students" strokeWidth={3} />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </CardContent>
//             </Card>

//             <Card className="bg-white/10 backdrop-blur-xl border-none rounded-2xl">
//               <CardContent className="p-6">
//                 <h3 className="mb-4 text-lg font-semibold">
//                   Monthly Enrollments
//                 </h3>
//                 <ResponsiveContainer width="100%" height={300}>
//                   <BarChart data={chartData}>
//                     <XAxis dataKey="month" />
//                     <YAxis />
//                     <Tooltip />
//                     <Bar
//                       dataKey="students"
//                       fill="#6A85B6"
//                       radius={[8, 8, 0, 0]}
//                     />
//                   </BarChart>
//                 </ResponsiveContainer>
//               </CardContent>
//             </Card>
//           </div>

//           {/* Admin Table */}
//           <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
//             <Card className="bg-white/10 backdrop-blur-xl border-none rounded-2xl">
//               <CardContent className="p-6">
//                 <h3 className="mb-4 text-lg font-semibold">Admin & Team</h3>
//                 <table className="w-full text-left">
//                   <thead className="text-gray-300">
//                     <tr>
//                       <th className="pb-3">Name</th>
//                       <th className="pb-3">Id</th>
//                       <th className="pb-3">Status</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {admins.map((admin) => (
//                       <tr key={admin.id} className="border-t border-white/10">
//                         <td className="py-3">{admin.name}</td>
//                         <td>{admin.adminId}</td>
//                         <td>
//                           <span
//                             className={`px-3 py-1 rounded-full text-sm ${
//                               {
//                                 Active: "bg-green-500/20 text-green-300",
//                                 Inactive: "bg-red-500/20 text-red-300",
//                               }[admin.status]
//                             }`}
//                           >
//                             {admin.status}
//                           </span>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </CardContent>
//             </Card>
//           </motion.div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AdminDashboard;

import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { GetRoute } from "../../Custom_hooks/Routes";
import { useMediaQuery } from "../../Custom_hooks/Custom";
import CustomModal from "Components/CustomComponents/CustomModal/CustomModal";
import CustomInput from "Components/CustomComponents/CustomInput/CustomInput";
import CustomButton from "Components/CustomComponents/CustomButton/CustomButton";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { Users, UserCheck, BarChart3, ShieldCheck } from "lucide-react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";

const Card = ({ className = "", children }) => (
  <div
    className={`rounded-3xl shadow-md border border-[#e0e7ff] bg-white ${className}`}
  >
    {children}
  </div>
);

const CardContent = ({ className = "", children }) => (
  <div className={className}>{children}</div>
);

const chartData = [
  { month: "Jan", students: 200 },
  { month: "Feb", students: 350 },
  { month: "Mar", students: 500 },
  { month: "Apr", students: 700 },
  { month: "May", students: 900 },
];

const AdminDashboard = () => {
  const isMobile = useMediaQuery("(max-width:700px)");

  const [length, setLength] = useState(0);
  const [popup, setpopup] = useState(false);

  const auth = useSelector((state) => state.user.auth);

  const admins = [
    {
      name: "Root User",
      adminId: "info@eduskillprep.com",
      status: "Active",
    },
   
  ];

  const handleFindTotalStudents = () => {
    GetRoute(
      `getAllUsers`,
      () => {},
      (data) => {
        setLength(data.length);
      },
    );
  };

  useEffect(() => {
    handleFindTotalStudents();
  }, []);

  const stats = [
    {
      title: "Total Students",
      value: `${length-1}+`,
      icon: Users,
    },
    {
      title: "Active Students",
      value: length-1,
      icon: UserCheck,
    },
    {
      title: "Tests Conducted",
      value: `50+`,
      icon: BarChart3,
    },
  ];

  return (
    <>
      {/* POPUP */}
      {popup && (
        <CustomModal isOpen={""} open={""} close={""}>
          <div>
            <div
              style={{
                fontSize: !isMobile ? "1.5vw" : "5vw",
                color: "#4f46e5",
                fontWeight: 700,
                marginBottom: "1rem",
              }}
            >
              Create New Admin
            </div>

            <CustomInput
              label={"Admin Name"}
              placeholder={"Enter admin name"}
            />

            <CustomInput
              label={"Admin Id"}
              placeholder={"Enter admin id/email id"}
            />

            <CustomInput
              label={"Password"}
              placeholder={"Enter admin password"}
            />

            <CustomInput
              label={"Select Features to Allocate"}
              inputStyle={{ display: "none" }}
            />

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              {["Question Database", "Upload Tests", "See Users"].map(
                (item, index) => (
                  <label
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: isMobile ? "3.5vw" : "0.95vw",
                    }}
                  >
                    <input
                      type="checkbox"
                      style={{
                        accentColor: "#4f46e5",
                        width: isMobile ? "18px" : "16px",
                        height: isMobile ? "18px" : "16px",
                      }}
                    />
                    {item}
                  </label>
                ),
              )}
            </div>

            <div style={{ display: "flex", gap: "12px" }}>
              <CustomButton
                text={"Save"}
                style={{
                  backgroundColor: "#4f46e5",
                }}
              />

              <CustomButton
                handleClick={() => setpopup(false)}
                text={"Cancel"}
                style={{
                  backgroundColor: "#ef4444",
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}

      <div className="dashboardContainer">
        <div className="min-h-screen bg-[#f5f7ff] p-4 md:p-6 text-gray-800">
          {/* HEADER */}
          <motion.div
            initial={{ opacity: 0, y: -15 }}
            animate={{ opacity: 1, y: 0 }}
            className="
              mb-8
              rounded-[30px]
              bg-gradient-to-r
              from-[#4f46e5]
              to-[#6366f1]
              p-6
              shadow-xl
              flex
              justify-between
              items-center
              flex-wrap
              gap-4
            "
          >
            <div>
              <h1 className="text-3xl font-bold text-white mb-1">
                Welcome Admin 👋
              </h1>

              <p className="text-white/80 text-sm">{auth?.data?.email}</p>
            </div>

            <div className="flex items-center gap-3">
              <div
                className="
                  w-14 h-14 rounded-full
                  bg-white/20
                  backdrop-blur-md
                  flex items-center justify-center
                  text-white text-2xl
                "
              >
                👤
              </div>
            </div>
          </motion.div>

          {/* STATS */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {stats.map((stat, index) => (
              <motion.div
                key={stat.title}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.08 }}
              >
                <Card className="overflow-hidden">
                  <CardContent className="p-6">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-sm text-gray-500 mb-2">
                          {stat.title}
                        </p>

                        <h2 className="text-3xl font-bold text-[#111827]">
                          {stat.value}
                        </h2>
                      </div>

                      <div
                        className="
                          w-14 h-14 rounded-2xl
                          bg-[#eef2ff]
                          flex items-center justify-center
                        "
                      >
                        <stat.icon className="text-[#4f46e5]" size={28} />
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>

          {/* CHARTS */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
            {/* LINE CHART */}
            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-2 mb-5">
                  <BarChart3 className="text-[#4f46e5]" size={20} />

                  <h3 className="text-lg font-semibold">Student Growth</h3>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={chartData}>
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />

                    <Line
                      type="monotone"
                      dataKey="students"
                      stroke="#4f46e5"
                      strokeWidth={4}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>

            {/* BAR CHART */}
            <Card>
              <CardContent className="p-6">
                <div className="flex items-center gap-2 mb-5">
                  <Users className="text-[#4f46e5]" size={20} />

                  <h3 className="text-lg font-semibold">Monthly Enrollments</h3>
                </div>

                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={chartData}>
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip />

                    <Bar
                      dataKey="students"
                      fill="#4f46e5"
                      radius={[10, 10, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </div>

          {/* ADMIN TABLE */}
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            <Card>
              <CardContent className="p-6">
                {/* TABLE HEADER */}
                <div className="flex justify-between items-center mb-5 flex-wrap gap-4">
                  <div className="flex items-center gap-2">
                    <ShieldCheck className="text-[#4f46e5]" size={22} />

                    <h3 className="text-xl font-semibold">Admin & Team</h3>
                  </div>

                  <button
                    onClick={() => setpopup(true)}
                    className="
                      bg-[#4f46e5]
                      hover:bg-[#4338ca]
                      text-white
                      px-5 py-2.5
                      rounded-xl
                      font-medium
                      transition-all
                    "
                  >
                    + Create Admin
                  </button>
                </div>

                {/* TABLE */}
                <div className="overflow-x-auto">
                  <table className="w-full min-w-[600px] border-separate border-spacing-y-3">
                    <thead>
                      <tr>
                        <th className="text-left text-gray-500 font-semibold px-4 py-2">
                          Name
                        </th>

                        <th className="text-left text-gray-500 font-semibold px-4 py-2">
                          Admin Id
                        </th>

                        <th className="text-left text-gray-500 font-semibold px-4 py-2">
                          Status
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {admins.map((admin, index) => (
                        <tr key={index} className="bg-[#f8faff]">
                          <td className="px-4 py-4 rounded-l-2xl font-semibold">
                            {admin.name}
                          </td>

                          <td className="px-4 py-4 text-gray-600">
                            {admin.adminId}
                          </td>

                          <td className="px-4 py-4 rounded-r-2xl">
                            <span
                              className="
                                px-4 py-1.5 rounded-full text-sm
                                bg-[#dcfce7]
                                text-[#15803d]
                                font-medium
                              "
                            >
                              {admin.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
